import React from 'react';

export const OverviewContext = React.createContext();

export const OverviewProvider = OverviewContext.Provider;
export const OverviewConsumer = OverviewContext.Consumer;
